import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center grain relative p-6">
      <div className="border border-border bg-card p-10 max-w-md w-full text-center" data-testid="payment-cancel">
        <XCircle size={48} weight="fill" className="mx-auto text-[hsl(var(--destructive))]" />
        <div className="uppercase-label mt-4">Payment cancelled</div>
        <h1 className="font-display text-2xl font-bold mt-2">No charges were made</h1>
        <p className="text-sm text-muted-foreground mt-2">You can retry the payment from the billing page.</p>
        <Link to="/billing" className="mt-6 inline-flex items-center gap-2 text-xs font-mono text-primary hover:underline">
          back to billing <ArrowRight size={12} />
        </Link>
      </div>
    </div>
  );
}
